module.exports = __webpack_public_path__ + "img/b89edc7.jpg";